import react from "react";
import FormControl from "@mui/material/FormControl";
import cancel from "../../Assests/cancel.svg";

interface DeleteRowsButtonProps {
  isEditEnabled: boolean;
  handleDeleteRows: () => void;
}
const DeleteRowsButton: React.FC<DeleteRowsButtonProps> = ({
  isEditEnabled,
  handleDeleteRows,
}) => {
  return (
    <div className="filter-item">
      <FormControl fullWidth>
        <div
          className={`add-row-span ${isEditEnabled ? "" : "disabled"}`}
          onClick={isEditEnabled ? handleDeleteRows : undefined}
        >
          <img src={cancel} alt="" /> <span>Delete&nbsp;Rows</span>
        </div>
      </FormControl>
    </div>
  );
};

export default DeleteRowsButton;
